export const ORDER_ENTRY_TYPES = {
  ORDER_ENTRY: 1,
  PAYMENT_METHOD: 2,
  PAYMENT_METHOD_SUBMIT: 3,
  VERIFICATION: 4,
};

export default {
  [ORDER_ENTRY_TYPES.ORDER_ENTRY]: 'OrderEntry',
  [ORDER_ENTRY_TYPES.PAYMENT_METHOD]: 'PaymentMethod',
  [ORDER_ENTRY_TYPES.PAYMENT_METHOD_SUBMIT]: 'PaymentMethodSubmit',
  [ORDER_ENTRY_TYPES.VERIFICATION]: 'Verification',
};
